import classnames from "classnames";
import { BORDER_STYLE } from "./constants";
import upperFirst from "lodash/upperFirst";
import uniq from "lodash/uniq";

export const getItemProps = ({
  item,
  index,
  currentIndex,
  onClick,
  afterClick,
  actions
}) => {
  const refVal = index - 1;
  const focused = refVal === currentIndex;

  const result = {
    tabIndex: index,
    id: `command-item-${index}`,
    key: item.id,
    className: classnames("w-100 pa3 bg-white--hover pointer", {
      "bg-whitesmoke": focused
    }),
    style: {
      ...BORDER_STYLE,
      borderColor: focused ? "black" : "transparent"
    }
  };

  if (item.perform) {
    if (item.perform.type) {
      const performAction = actions[item.perform.type];
      if (performAction) {
        result.onClick = () => {
          actions[item.perform.type](item.perform.props);
          afterClick && setTimeout(afterClick, 0);
        };
      } else {
        console.error(
          `Unsupported perform type: ${item.perform.type}. Make sure ${item.perform.type} has a corresponding key within actions.`
        );
      }
    } else if (typeof item.perform === "function") {
      result.onClick = () => {
        item.perform();
        afterClick && setTimeout(afterClick, 0);
      };
    } else {
      console.error("Invalid perform configuration", item.perform);
    }
  } else if (onClick) {
    result.onClick = onClick;
  }

  return result;
};

export const getBreadcrumbs = ({ item, commandsMap }) => {
  let result;
  const parts = [];
  if (item.parent) {
    const parent = commandsMap[item.parent];

    if (parent.section) {
      parts.push(parent.section);
    }
    if (parent.name) {
      parts.push(parent.name);
    }
  }

  if (item.section) {
    parts.push(item.section);
  }

  result = uniq(parts)
    .map((part) => upperFirst(part))
    .join(" > ");
  if (result) {
    result += ` >`;
  }

  return result;
};
